export default __webpack_public_path__ + "static/media/Background_00080.ee3c8f4c.png";